module.exports = __webpack_public_path__ + "img/side.65e5311b.png";